import { gateway } from "../../../gateway";

export const getMessages = async ({ page = 1, pageSize = 50, order, receiveIdentifier, receiverType = "workforce", search = "" }) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("pageSize", pageSize.toString());
    params.append("order", order);
    params.append("receiveIdentifier", receiveIdentifier)
    params.append("receiverType", receiverType)

    if (search.trim()) params.append("search", search.trim());

    const res = await gateway.get(`/messages?${params.toString()}`);

    return res.data;
  } catch (error) {
    console.error("Error in getMessages:", error);
    throw error;
  }
};
